<template>
    <van-nav-bar title="Apertura de Cuenta" fixed left-arrow @click-left="onClickLeft" placeholder />
    <div class="page">
        <div class="zhuce">
            <van-form @failed="onFailed" @submit="onSubmit">
                <div class="title" style="margin-top: 0;">Número de teléfono</div>
                <van-field v-model="username" name="username" type="number"
                    placeholder="Por favor ingrese su número de teléfono"
                    :rules="[{ required: true, message: 'Ingrese su número telefónico' }, { pattern: /^\d{5,14}$/, message: 'Formato incorrecto' }]">
                    <template #label>
                        <div @click="opqh"> +{{ areaCode }} <van-icon name="arrow-down" /></div>
                    </template>
                </van-field>
                <div class="title">contraseña</div>
                <van-field v-model="password" name="password" :type="isShowPassword ? 'text' : 'password'"
                    placeholder="Por favor ingrese su contraseña"
                    :rules="[{ required: true, message: 'Ingrese una contraseña' }, { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/, message: 'Mínimo 6 caracteres con combinación de letras y números' }]">
                    <template #right-icon>
                        <span class="solts"><van-icon :name="isShowPassword ? 'eye-o' : 'closed-eye'"
                                @click="isShowPassword = !isShowPassword" /></span>
                    </template>
                </van-field>
                <div class="title">confirmar Contraseña</div>
                <van-field v-model="confirmPassword" name="confirmPassword"
                    :type="isShowConfirmPassword ? 'text' : 'password'"
                    placeholder="Por favor ingrese la contraseña nuevamente"
                    :rules="[{ required: true, message: 'Confirme la contraseña' }, { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/, message: 'Mínimo 6 caracteres con combinación de letras y números' }, { validator: validateConfirm, message: 'Las contraseñas no coinciden' }]">
                    <template #right-icon>
                        <span class="solts"><van-icon :name="isShowConfirmPassword ? 'eye-o' : 'closed-eye'"
                                @click="isShowConfirmPassword = !isShowConfirmPassword" /></span>
                    </template>
                </van-field>
                <div class="title">Código de invitación (obligatorio)</div>
                <van-field v-model="invite" type="text" name="invite" placeholder="Código de invitación (obligatorio)"
                    :rules="[{ required: true, message: 'Ingrese el código de invitación' }]" />
                <div class="btn-box">
                    <van-button type="default" class="btn" :loading="loading"
                        loading-text="Apertura de cuenta en proceso..." native-type="submit">Apertura de cuenta
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>
    <!-- 区号选择 -->
    <van-popup v-model:show="showPicker" destroy-on-close :key="showPicker" round position="bottom">
        <van-picker confirm-button-text="Confirmar" cancel-button-text="Cancelar" :model-value="pickerValue"
            :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
</template>
<script setup name="BullMarketBrokers">
import { showSuccessToast } from "vant"
import { register } from "@/api"
const onClickLeft = () => history.back()
import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()
const isShowPassword = ref(false)
const isShowConfirmPassword = ref(false)
const areaCode = ref('54')
const username = ref('')
const password = ref('')
const confirmPassword = ref('')
const invite = ref(route.query.invite || '')

const validateConfirm = () => {
    return confirmPassword.value === password.value
}

const onFailed = (errorInfo) => {
    console.log('failed', errorInfo);
};
const loading = ref(false)
const onSubmit = (values) => {
    loading.value = true
    register({
        ...values,
        username: areaCode.value + values.username,
        confirmPassword: undefined
    }).then(res => {
        if (res.code == 200) {
            showSuccessToast(res.message)
            router.push('/success')
        }
        loading.value = false
    }).catch(() => {
        loading.value = false
    })
};

// 区号选择
const opqh = () => {
    showPicker.value = true
}
const columns = [
    { text: '54', value: '54' },
    { text: '1', value: '1' },
];
const fieldValue = ref('');
const showPicker = ref(false);
const pickerValue = ref(['54']);
const onConfirm = ({ selectedOptions }) => {
    showPicker.value = false;
    pickerValue.value = [selectedOptions[0].value];
    fieldValue.value = selectedOptions[0].text;
    areaCode.value = pickerValue.value[0]
};
</script>
<style scoped lang="scss">
.page {
    padding: 15px;
    background-color: #fdfdfe;
    min-height: 100vh;
}

.zhuce {
    box-shadow: 0 6px 10px rgba(0, 34, 158, .05), 0 1px 18px rgba(0, 34, 158, .05);
    border-radius: 4px;
    background-color: #fff;
    padding: 15px;

    :deep(.van-badge__wrapper) {
        color: #cac6b6;
    }

    .van-tag {
        margin-bottom: 20px;
    }

    .tag-con {
        padding: 10px;
        font-size: 16px;
        color: #8a6d3b;
    }

    .login-from {
        padding: 10px 15px 0;
    }

    .title {
        margin-bottom: 10px;
        margin-top: 25px;
        font-size: 15px;
        font-weight: bold;
    }

    .is-active-1 {
        border-top-left-radius: 0;
        border-top-right-radius: 20px;
    }

    .van-cell {
        border-radius: 8px;
        opacity: 1;
        background: #f5f8fa;
        box-sizing: border-box;
        color: #ec3e33;
        margin-bottom: 15px;
    }

    :deep(.van-cell__title) {
        width: 80px;
        color: #000;
        border-right: 1px solid #a2a7aa;

        i {
            margin-left: 10px;
        }
    }

    .forgot-pwd {
        font-size: 12px;
        color: #ec3e33;
        text-align: right;
        margin-top: 10px;
        margin-bottom: 50px;
        display: flex;
        align-content: center;
        justify-content: space-between;
        gap: 10px;

        .online-service {
            text-align: center;
            font-size: 12px;
            color: #ec3e33;
        }
    }

    .btn-box {
        border-radius: 8px;
        overflow: hidden;
        margin-top: 30px;

        .btn {
            width: 100%;
            color: white;
            background: #1e27f3;
            border-color: #1e27f3;
        }
    }

    .login-footer {
        text-align: center;
        font-size: 12px;
        color: #a7afb7;
        margin-top: 15px;
    }
}
</style>